/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';
import { API_OPTIONS_CONTEXT, ApiOptions }                   from '../api/api'

// @ts-ignore
import { AvatarRequest } from '../model/avatarRequest';
// @ts-ignore
import { AvatarResponse } from '../model/avatarResponse';
// @ts-ignore
import { BaseResponse } from '../model/baseResponse';
// @ts-ignore
import { DeleteAvatarResponse } from '../model/deleteAvatarResponse';
// @ts-ignore
import { PermissionDeniedResponse } from '../model/permissionDeniedResponse';
// @ts-ignore
import { UnauthorizedResponse } from '../model/unauthorizedResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface DeleteUsersAvatarRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface PatchUsersAvatarRequestParams {
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Запрос на обновление фотографии пользователя */
    avatarRequest: AvatarRequest;
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Уникальный идентификатор устройства */
    xDeviceID?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Токен доступа для аутентификации в Паспорте в формате JWT.  На текущий момент в АГВ проверяется только актуальность токена по утверждению \&quot;exp\&quot;.  Токен проверяется только при условиях: - в запросе передан PassportAccessToken - метод имеет скоуп безопасности PassportAccessToken - в GrowthBook включен и настроен фича тоггл agw25_passport_access_token_check:   - platformsEnabled - для каких значений X-Platform будет включена аутентификация   - experimentsEnabled - для каких экспериментов будет включена аутентификация   - routesDisabled - для каких маршрутов будет выключена аутентификация  Документация токена (может быть не актуальна):  https://confluence.lenta.com/pages/viewpage.action?pageId&#x3D;110446324  */
    passportAccessToken?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}


@Injectable({
  providedIn: 'root'
})
export class UsersAvatarService {

    protected basePath = 'https://api.lenta.com/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Удаление фотографии пользователя
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteUsersAvatar(requestParameters: DeleteUsersAvatarRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<DeleteAvatarResponse>;
    public deleteUsersAvatar(requestParameters: DeleteUsersAvatarRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<DeleteAvatarResponse>>;
    public deleteUsersAvatar(requestParameters: DeleteUsersAvatarRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<DeleteAvatarResponse>>;
    public deleteUsersAvatar(requestParameters: DeleteUsersAvatarRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling deleteUsersAvatar.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling deleteUsersAvatar.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/users/avatar`;
        return this.httpClient.request<DeleteAvatarResponse>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Обновление фотографии пользователя
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchUsersAvatar(requestParameters: PatchUsersAvatarRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<AvatarResponse>;
    public patchUsersAvatar(requestParameters: PatchUsersAvatarRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<AvatarResponse>>;
    public patchUsersAvatar(requestParameters: PatchUsersAvatarRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<AvatarResponse>>;
    public patchUsersAvatar(requestParameters: PatchUsersAvatarRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling patchUsersAvatar.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling patchUsersAvatar.');
        }
        const avatarRequest = requestParameters.avatarRequest;
        if (avatarRequest === null || avatarRequest === undefined) {
            throw new Error('Required parameter avatarRequest was null or undefined when calling patchUsersAvatar.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceID = requestParameters.xDeviceID;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const passportAccessToken = requestParameters.passportAccessToken;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceID !== undefined && xDeviceID !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-ID', String(xDeviceID));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (passportAccessToken !== undefined && passportAccessToken !== null) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', String(passportAccessToken));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarCredential: string | undefined;
        // authentication (SessionToken) required
        localVarCredential = this.configuration.lookupCredential('SessionToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('SessionToken', localVarCredential);
        }

        // authentication (DeviceId) required
        localVarCredential = this.configuration.lookupCredential('DeviceId');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('DeviceId', localVarCredential);
        }

        // authentication (PassportAccessToken) required
        localVarCredential = this.configuration.lookupCredential('PassportAccessToken');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('PassportAccessToken', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'CL',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/users/avatar`;
        return this.httpClient.request<AvatarResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: avatarRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
